<template>
    <div></div>
</template>

<script>
    export default {
        name: "Logout",
        created: function () {
            this.$store.dispatch("logout")
            this.$router.push('/login')
        }
    }
</script>

<style scoped>

</style>